import deepMerge from 'deepmerge';

import createMessageForm from '@bundles/Messages/MessageCreate/components/CreateMessageForm/translations';
import messageReplyForm from '@bundles/Messages/MessageDisplay/MessageReply/components/MessageReplyForm/translations';
import elsterPassWordForm from '@pages/Filing/FilingDetailPage/components/FilingSubmission/components/PasswordEntryForm/translations';
import jurisdictionsSaga from '@sagas/jurisdictions/translations';

import components from './components';
import containers from './containers';
import pages from './pages';

export default deepMerge.all([
  components,
  pages,
  containers,
  elsterPassWordForm,
  createMessageForm,
  messageReplyForm,
  jurisdictionsSaga,
]);
